// Lightweight anonymous usage analytics for knaxly.dev/quanta.
// Fire-and-forget; never throws. Mirrors the other knaxly.dev tools:
// sends a plain text/plain JSON string so cross-origin sendBeacon stays a
// CORS-safelisted request. Respects a per-browser test flag (?kx_test=1).
const EP = "https://knaxly-events.nirocr.workers.dev/e";

function gid(key: string, store: Storage): string {
  try {
    let v = store.getItem(key);
    if (!v) {
      v =
        self.crypto && crypto.randomUUID
          ? crypto.randomUUID()
          : Date.now().toString(36) + Math.random().toString(36).slice(2);
      store.setItem(key, v);
    }
    return v;
  } catch {
    return "";
  }
}

export function track(event: string, detail = "", value?: number): void {
  try {
    const body: Record<string, unknown> = {
      tool: "quanta",
      event,
      detail,
      vid: gid("kx_vid", localStorage),
      sid: gid("kx_sid", sessionStorage),
      path: location.pathname,
      ref: document.referrer || "",
    };
    if (typeof value === "number" && isFinite(value)) body.value = value;
    try {
      const q = location.search;
      if (q.indexOf("kx_test=1") > -1) localStorage.setItem("kx_test", "1");
      if (q.indexOf("kx_test=0") > -1) localStorage.removeItem("kx_test");
      if (localStorage.getItem("kx_test") === "1") body.test = 1;
    } catch {
      /* ignore */
    }
    const s = JSON.stringify(body);
    if (navigator.sendBeacon) navigator.sendBeacon(EP, s);
    else fetch(EP, { method: "POST", body: s, keepalive: true }).catch(() => {});
  } catch {
    /* analytics must never break the app */
  }
}
